var map = {
	"./tabs-01.jpg": "6a78",
	"./tabs-02.jpg": "9ff7",
	"./tabs-03.jpg": "9f4e",
	"./tabs-04.jpg": "bc96",
	"./tabs-05.jpg": "4bff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ea6";